export default {
    bookmarks: 'Bookmarks',
    bookmarkedFriendsOnline: '{count} bookmarked friends are online',
    cancel: 'Cancel',
    clearAlerts: 'Clear Alerts',
    friends: 'Online Friends',
    history: 'History',
    bookmarkedFriends: 'Bookmarked Friends',
    manage: 'Manage',
    manageInYour: 'in your',
    manageList: 'list',
    manageNoMatches: 'There are no matches for',
    manageYouHaveNotAdded: 'You have not added any',
    memberFriends: 'Member Friends',
    modelFriends: 'Model Friends',
    noBookmarksOffline: 'No bookmarked models offline',
    noBookmarksOnline: 'No bookmarked models online',
    noFriends: 'You have no friends or bookmarks online',
    noModelOrMemberFriendsOnline: 'No model or member friends online',
    noFriendsOffline: 'No model friends offline',
    noFriendsOnline: 'No model friends online',
    noFriendsBroadcasting: 'No friends online',
    noBookmarksBroadcasting: 'No bookmarks online',
    noMembersOffline: 'No member friends offline',
    noMembersOnline: 'No member friends online',
    noSearchResults: 'No online friends or bookmarks match this search query',
    offlineBookmarkedFriends: 'Offline Bookmarked Friends',
    offline: 'Offline',
    offlineBookmarks: 'Offline Bookmarks',
    offlineMemberFriends: 'Offline Member Friends',
    offlineModelFriends: 'Offline Model Friends',
    onlineBookmarks: 'Online Bookmarks',
    online: 'Online',
    onlineMemberFriends: 'Online Member Friends',
    onlineModelFriends: 'Online Model Friends',
    onlineBookmarkedFriends: 'Online Bookmarked Friends',
    broadcastingFriends: 'Broadcasting Model Friends',
    broadcastingBookmarkedFriends: 'Broadcasting Bookmarked Friends',
    broadcastingBookmarks: 'Broadcasting Bookmarks',
    openRoom: 'Open Room',
    openRooms: 'Open Rooms',
    recentMessages: 'Recent Messages',
    searchPlaceholderText: 'Search for a friend or bookmark',
    alerts: 'Notify Model Activity (Header)',
    onlineNotifications: 'Go live / change status',
    news: 'Post to News Feed',
    both: 'All Activity',
    none: 'None',
    panel: 'Models You May Like',
    popularRooms: 'Most Popular Rooms',
    trendingRooms: 'Trending Rooms',
    newModels: 'New Models',
    recentlyVisited: 'Recently Visited',
    missMFC: 'Miss MyFreeCams',
    tagsTopics: 'Tags & Topics',
    customSelections: 'Custom Selections',
    myWebcamViewers: 'My Webcam Viewers',
}
